import React from 'react'
import { Col, Row } from 'reactstrap'
import roundRightArrow from '../../../images/roundRightArrow.png'
import './index.css'

export const DealerListCard = ({ subTitle1, subTitle2, count1, count2, cardData, handleTitleClick, hnandleSHFtdClick, hnandleSHMtdClick }) => {

    const { first_name, last_name, role, state } = cardData
    return (
        <div className="dealerCard" id='dealerListCard'>
            <div className="dealerCardTitle m-0" onClick={((role === "SH" || role === "NH")) ? handleTitleClick : hnandleSHFtdClick}
                style={{ cursor: 'pointer' }}
            >
                <div className='flex-grow-1'>{`${role}  ${state ? `(${state})` : ''} : ${first_name} ${last_name}`}</div>
                <div className='titleArrow'>
                    <img src={roundRightArrow} alt="roundRightArrow" />
                </div>
            </div>
            <div className="dealerCardInner">
                <Row className="justify-content-center">
                    <Col>
                        <div className='dealerCardBlock'>
                            <div className='dealerCardSubTitle'>{subTitle1}</div>
                            <div className='dealerNumber green' onClick={hnandleSHFtdClick}>{count1}</div>
                        </div>
                    </Col>
                    <Col>
                        <div className='dealerCardBlock'>
                            <div className='dealerCardSubTitle'>{subTitle2}</div>
                            <div className='dealerNumber red' onClick={hnandleSHMtdClick}>{count2}</div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div >
    )
}